import React from "react";
import {TextField,Autocomplete} from '@mui/material';

export default function AutoCompleteTextField(props){
    const {name,
      label='Item',
      data=[],
      value,
      onChange,
      error,
      ...others
    } = props;
    return ( <Autocomplete
        {...others}
        options={data}
        renderInput={(params) => (
          <TextField
              {...params} 
              label={label}
              error={error}
              helperText={error}
          />
        )}
        value={value}
        fullWidth
        placeholder={`Select a ${label}`}
        onChange={onChange}
      />);
}